export const GET_ALL_SHIPPING_COMPANIES = "/shipping-companies"

export const GET_ALL_SHIPPING_COMPANIES_PARANOID = "/shipping-companies/all"

export const GET_ALL_SHIPPING_COMPANIES_PARANOID_WITH_PRODUCTS =
  "/shipping-companies/all/products"

export const GET_SHIPPING_COMPANY_BY_ID = "/shipping-companies/:id"

export const POST_SHIPPING_COMPANY = "/shipping-companies"

export const UPDATE_COMPANY_BY_ID = "/shipping-companies/:id"

export const DELETE_COMPANY_BY_ID = "/shipping-companies/:id"

export const RESTORE_COMPANY_BY_ID = "/shipping-companies/:id/restore"

export const GET_SHIPPING_EVENTS_WITH_MAPPING =
  "/shipping-companies/status-mapping/:id"

export const GET_STATUS = "/status"

export const GET_SHIPPING_EVENT = "/shipping-events/:id"

export const UPDATE_SHIPPING_EVENT = "/shipping-events/:id"

export const UPDATE_SHIPPING_COMPANIES = "/shipping-companies/sla"
